import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const IncomingCahsTransferFromAnotherAccountDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return <Row></Row>;
};

export default IncomingCahsTransferFromAnotherAccountDetail;
